import React from "react";
import {Card, CardBody, CardHeader, CardHeaderToolbar} from "../../../_metronic/_partials/controls";
import FactorsTable from "./FactorsTable";
import {OrderEdit} from "./order-edit/OrderEdit";
import FactorForm from "./FactorForm";

export default function FactorCreate() {

    const data="";
    return (
        <>
            <Card>
                <CardHeader title="ایجاد فاکتور">
                    <CardHeaderToolbar>
                        <button
                            type="button"
                            className="btn btn-info ml-2"
                            onClick={() => {
                                window.location.href='/admin/factors'
                            }}>
                            بازگشت
                        </button>
                    </CardHeaderToolbar>
                </CardHeader>
                <CardBody>

                <FactorForm
                    data={data}
                />

                </CardBody>
            </Card>
        </>
    )

}